module.exports = __webpack_public_path__ + "static/brand-8878b9536cadaff829e09fa4a8da919e.png";